const hashTagChecker = (text) => {
  const char = text[0];
  return text.indexOf('#') === 0 ? text.replace(char, '%23') : text;
};

export default hashTagChecker;
